import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { Guid } from "@/Common/Models/Guid";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { CreateFlowsheetTemplateRequest } from "./Contracts/CreateFlowsheetTemplate";
import { GetFlowsheetTemplateResponse } from "./Contracts/GetFlowsheetTemplate";
import { IGetFlowsheetTemplateNameExistsResponse } from "./Contracts/GetFlowsheetTemplateNameExists";
import { GetFlowsheetTemplatesResponse } from "./Contracts/GetFlowsheetTemplates";

class FlowsheetTemplateClient {
    /**
     * Get the list of flowsheet templates
     */
    public static async getFlowsheetTemplates({ patientId, includeDefaultTemplates }: { patientId?: Guid, includeDefaultTemplates?: boolean } = {}): Promise<ClientResponse<GetFlowsheetTemplatesResponse>> {
        return await Client.postAsync<GetFlowsheetTemplatesResponse>(ServerOperations.Server.Myle_FlowsheetModule_GetFlowsheetTemplatesMetadata, { patientId, includeDefaultTemplates });
    }

    /**
     * Get the flowsheet template by ID
     */
    public static async getFlowsheetTemplate(templateId: Guid): Promise<ClientResponse<GetFlowsheetTemplateResponse>> {
        return await Client.postAsync<GetFlowsheetTemplateResponse>(ServerOperations.Server.Myle_FlowsheetModule_GetFlowsheetTemplate, { Id: templateId });
    }

    /**
     * Check if the template name already exists
     * @param name The name of the template to check for duplicates
     * @returns True if the template name already exists, false otherwise
     */
    public static async getFlowsheetTemplateNameExists(name: string, suggestName: boolean): Promise<ClientResponse<IGetFlowsheetTemplateNameExistsResponse>> {
        return await Client.postAsync<IGetFlowsheetTemplateNameExistsResponse>(ServerOperations.Server.Myle_FlowsheetModule_GetFlowsheetTemplateNameExists, { name, suggestName });
    }

    /**
     * Delete the flowsheet template
     */
    public static async deleteFlowsheetTemplate(templateId: Guid): Promise<ClientResponse<void>> {
        return await Client.postAsync<void>(ServerOperations.Server.Myle_FlowsheetModule_DeleteFlowsheetTemplate, { Id: templateId });
    }

    /**
     * Create a flowsheet template
     */
    public static async createFlowsheetTemplate(request: CreateFlowsheetTemplateRequest): Promise<ClientResponse<void>> {
        return await Client.postAsync<void>(ServerOperations.Server.Myle_FlowsheetModule_CreateFlowsheetTemplate, request);
    }
}

export { FlowsheetTemplateClient };
